(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;
      this.header.classList.add('tb-persistent-header');
      this.onScrollHandler = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateOrderButton();
        });
      };
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler);
      window.addEventListener('pageshow', this.onScrollHandler);
      this.updateOrderButton();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onScrollHandler);
      cancelAnimationFrame(this.frame);
    }

    updateOrderButton() {
      if (!this.header) return;
      // Keep the homepage logo visible at the top and during pull-to-refresh.
if (this.dataset.pageType === 'index' && window.scrollY <= 10) {
  this.header.classList.remove('tb-show-order');
  return;
}
      const headerBottom = this.header.getBoundingClientRect().bottom;
      const pageButtons = document.querySelectorAll(
        '#MainContent a[href*="/products/proper-dtf"], #MainContent button, #MainContent input[type="submit"]'
      );
      const orderingButtonVisible = Array.from(pageButtons).some((button) => {
        const label = (button.textContent || button.value || '').trim();
        const isOrderButton =
          button.matches('a[href*="/products/proper-dtf"]') ||
          /order transfers/i.test(label) ||
          (this.dataset.pageType === 'product' && button.matches('[name="add"]'));
        if (!isOrderButton) return false;
        const style = getComputedStyle(button);
        const rect = button.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' &&
          Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 &&
          rect.bottom > headerBottom && rect.top < window.innerHeight &&
          rect.right > 0 && rect.left < window.innerWidth;
      });
      const slot = this.querySelector('.header-brand-slot');
      if (!slot || !slot.contains(document.activeElement)) {
        this.header.classList.toggle('tb-show-order', !orderingButtonVisible);
      }
    }
  }

  window.addEventListener('load', function() {
    const parallaxImage = document.querySelector('sticky-header .header__heading-logo.desktop-only');
    if (!parallaxImage) {
      return
    }

    const computedStyle = getComputedStyle(parallaxImage);
    const originalWidth = parseFloat(computedStyle.width);
    
    window.addEventListener('scroll', function() {
      const scrolled = window.scrollY;
      
      if (originalWidth > 250) {
        let targetWidth = originalWidth - (originalWidth * scrolled / 500); // Adjust this value to control the reduction rate

        if (targetWidth < 180) {
          targetWidth = 180;
        }

        parallaxImage.style.width = `${targetWidth}px`;
      }
    });
  });

  customElements.define('sticky-header', StickyHeader);

  function getBrightnessFromRGB(rgbString) {
    const rgb = rgbString.match(/\d+/g);
    if (!rgb || rgb.length < 3) return 255;

    const [r, g, b] = rgb.map(Number);
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  function updateLogoBasedOnBrightness(isDark) {
    const desktopLogo = document.querySelector('.header__heading-logo.desktop-and-tablet-only');
    const mobileLogo = document.querySelector('.header__heading-logo.small-mobile-only');

    if (desktopLogo) {
      const defaultDesktopLogo = desktopLogo.dataset.defaultLogo;
      const darkDesktopLogo = desktopLogo.dataset.darkLogo;
      const desktopSrc = isDark && darkDesktopLogo ? darkDesktopLogo : defaultDesktopLogo;

      if (desktopLogo.src !== desktopSrc) {
        desktopLogo.addEventListener('load', updateNavHeight, { once: true });
        desktopLogo.src = desktopSrc;
      } else {
        updateNavHeight(); // still update height in case layout changed
      }
    }

    if (mobileLogo) {
      const defaultMobileLogo = mobileLogo.dataset.defaultLogo;
      const darkMobileLogo = mobileLogo.dataset.darkLogo;
      const mobileSrc = isDark && darkMobileLogo ? darkMobileLogo : defaultMobileLogo;

      if (mobileLogo.src !== mobileSrc) {
        mobileLogo.addEventListener('load', updateNavHeight, { once: true });
        mobileLogo.src = mobileSrc;
      } else {
        updateNavHeight();
      }
    }
  }

  function updateNavHeight() {
    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader) {
      document.documentElement.style.setProperty('--nav-height', `${sectionHeader.offsetHeight}px`);
    }
  }

  function updateMatchBanner() {
    const collectionHero = document.querySelector(".collection-hero");
    const articleHero = document.querySelector(".article-hero");
    const pageWithHeader = document.querySelector(".page-with-header");
    const firstBanner = document.querySelector(".shopify-section:first-of-type:has(.banner-full-width) .banner");
    const matchBanner = document.querySelector(".match-banner-style");
    const sectionHeader = document.querySelector(".section-header");

    if (!matchBanner || !sectionHeader) return;

    let colorClass = null;
    let hasElement = false;

    if (articleHero) {
        const heroClasses = Array.from(articleHero.classList);
        colorClass = heroClasses.find(cls => cls.startsWith("color-"));
        hasElement = true;
    }

    if (collectionHero) {
        const heroClasses = Array.from(collectionHero.classList);
        colorClass = heroClasses.find(cls => cls.startsWith("color-"));
        hasElement = true;
    }

    if (!colorClass && pageWithHeader) {
        const headerClasses = Array.from(pageWithHeader.classList);
        colorClass = headerClasses.find(cls => cls.startsWith("color-"));
        hasElement = true;
    }

    if (!colorClass && firstBanner) {
        const bannerClasses = Array.from(firstBanner.classList);
        colorClass = bannerClasses.find(cls => cls.startsWith("color-"));
        hasElement = true;
    }

    if (!matchBanner.dataset.originalColor) {
      const original = Array.from(matchBanner.classList).find(cls => cls.startsWith("color-"));
      if (original) {
        matchBanner.dataset.originalColor = original;
      }
    }

    if (hasElement == true) {
      // Remove existing color-... classes from match-banner-style
      matchBanner.classList.forEach(cls => {
        if (cls.startsWith("color-")) {
          matchBanner.classList.remove(cls);
        }
      });

      // Add the extracted color class
      matchBanner.classList.add(colorClass);
    }


    // Add match-banner-style--true if one of the elements is present
    if (hasElement == true) {
        matchBanner.classList.add("match-banner-style--true");
    } else {
      matchBanner.classList.remove("match-banner-style--true");
      const originalColor = matchBanner.dataset.originalColor;
      if (originalColor) {
        // Remove any current color-* classes first
        Array.from(matchBanner.classList).forEach(cls => {
          if (cls.startsWith("color-")) {
            matchBanner.classList.remove(cls);
          }
        });
        matchBanner.classList.add(originalColor);
      }
    }

    let bgSourceEl = collectionHero || articleHero || pageWithHeader || firstBanner;
    let isDark = false;

    if (bgSourceEl) {
      const bgColor = getComputedStyle(bgSourceEl).backgroundColor;
      const brightness = getBrightnessFromRGB(bgColor);
      isDark = brightness < 100;
      updateLogoBasedOnBrightness(isDark); // your logo swap logic
    }

    // Update CSS variable for nav height
    document.documentElement.style.setProperty('--nav-height', `${sectionHeader.offsetHeight}px`);
  }

  // Update on load, section load, resize, and orientation change
  document.addEventListener("DOMContentLoaded", updateMatchBanner);
  window.addEventListener("resize", updateMatchBanner);
  window.addEventListener("orientationchange", updateMatchBanner);

  function delayedUpdateMatchBanner() {
    setTimeout(updateMatchBanner, 0);
  }

  document.addEventListener("shopify:section:load", delayedUpdateMatchBanner);
  document.addEventListener("shopify:section:unload", delayedUpdateMatchBanner);
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
